import { render, staticRenderFns } from "./PeopleManager.vue?vue&type=template&id=f228e9cc&scoped=true"
import script from "./PeopleManager.vue?vue&type=script&lang=js"
export * from "./PeopleManager.vue?vue&type=script&lang=js"
import style0 from "./PeopleManager.vue?vue&type=style&index=0&id=f228e9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f228e9cc",
  null
  
)

export default component.exports